import { Entity, Field } from "typegraph";

@Entity({ one: "knowledgeBase" })
export default class KnowledgeBase {
	@Field()
	public id: any;

	@Field()
	public guid: string;
}



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/entities/KnowledgeBase.ts